import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Input, Modal, Alert, Typography, Spin, Divider, Tag, Space, Form } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import BarcodeScanner from "../../Comman/Scanner/BarCodeScanner";

const { Title, Text } = Typography;

const SendToFinishing = () => {
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();

    const handleTagClick = () => {
        setIsModalOpen(true);
    };

    const handleSubmit = (values) => {
        const binId = values.binId;
        if (!binId) {
            setError("Please provide a valid scanned data or enter it manually");
            return;
        }
        try {
            setIsLoading(true);
            navigate(`/kca/kanban-sent-finishing/confirm?kanbanId=${encodeURIComponent(binId)}`);
        } catch (error) {
            setError("An error occurred while processing the kanban data");
            setIsLoading(false);
        }
    };

    const handleScan = (result) => {
        setIsModalOpen(false);
        handleSubmit({ binId: result });
    };

    const handleScanError = (error) => {
        setError("Error accessing camera. Please try manual input or check camera permissions.");
        console.error(error);
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Tag
                    style={{ width: "300px", height: "90px", color: "#fff", backgroundColor: "#2db7f5", display: "flex", justifyContent: "center", alignItems: "center", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", borderRadius: "10px", cursor: "pointer" }}
                    onClick={handleTagClick}
                >
                    <Text strong style={{ fontSize: "20px", color: "white" }}>SCAN HERE</Text>
                </Tag>

                <Space size="large" style={{ padding: "20px 0" }}>
                    <Text strong>OR</Text>
                </Space>

                <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ width: "300px" }}>
                    <Form.Item name="binId" label="Enter Kanban ID Manually" rules={[{ required: true, message: "Kanban ID cannot be empty. Please provide a valid ID." }]}>
                        <Input size="large" style={{ textAlign: "center" }} />
                    </Form.Item>
                    <Form.Item>
                        <Button size="large" type="primary" htmlType="submit" block>Submit</Button>
                    </Form.Item>
                </Form>
            </div>

            <Modal title="Scan Bar Code" open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null}>
                <BarcodeScanner onScan={handleScan} onError={handleScanError} />
            </Modal>
        </>
    );
};

export default SendToFinishing;
